import { Navigate, Route, Routes } from 'react-router-dom';

import { PERMISSION } from 'src/features/auth';
import Validation from 'src/features/validation/components/Validation';
import { ValidationLayout } from 'src/features/validation/components/ValidationLayout';
import useHasPermissions from 'src/hooks/useHasPermissions';

const ValidationRoutes = () => {
    const permissionValidation = useHasPermissions([PERMISSION.VEHICLE_VALIDATION]);

    return permissionValidation ? (
        <Routes>
            <Route path="" element={<ValidationLayout />}>
                <Route path="" element={<Validation />} />
                <Route path="*" element={<Navigate to=".." />} />
            </Route>
        </Routes>
    ) : (
        <Navigate to=".." />
    );
};

export default ValidationRoutes;
